import api from 'api';
import storage from "@/cflow/storageService";

class EstoqueCatService {

    listar(tipo, lab_id) {
        return new Promise((resolve, reject) => {
            const user = storage.get('user');
            api.get('/estoque-categoria?lab_id='+lab_id+'&tipo='+tipo+'&token='+user.token).then((result) => {
                resolve(result.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }

    detalhes(id) {
        return new Promise((resolve, reject) => {
            const user = storage.get('user');
            api.get('/estoque-categoria/' + id + '?token='+user.token).then((result) => {
                resolve(result.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }

    salvar(id, form) {
        return new Promise((resolve, reject) => {
            const user = storage.get('user');
            api.post('/estoque-categoria/' + id + '?token='+user.token, form).then((result) => {
                resolve(result.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }

    remove(id) {
        return new Promise((resolve, reject) => {
            const user = storage.get('user');
            api.delete('/estoque-categoria/' + id + '?token='+user.token).then((result) => {
                resolve(result.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }

}
export default new EstoqueCatService();